{
  "END_USER": "Utilisateur final",
  "MFA_REQUIRED": "Mfa requis",
  "COMPANY_INFORMATION": "Informations sur la société",
  "COMPANY_NAME": "Nom société",
  "ADDRESS1": "Adresse",
  "ADDRESS2": "Complément adresse",
  "ZIP": "Code postal",
  "CITY": "Ville",
  "ORG_NUMBER": "Siret",
  "EMAIL_ADDRESS": "Email",
  "TELEPHONE": "Téléphone",
  "WEBADDRESS": "Adresse mail",
  "QUOTATION": "Devis",
  "NAME": "Nom",
  "CUSTOMER": "Client",
  "YOUR_REFERENCE": "Votre référence",
  "PAYMENT_TERMS": "Conditions de paiement",
  "DATE": "Date",
  "EXPIRE_DATE": "Date d'expiration",
  "OUR_REFERENCE": "Notre référence",
  "DELIVERY_TERMS": "Modalités de livraison",
  "NOTES": "Commentaires",
  "PRICE_SUMMARY": "Devis",
  "ART_NO": "Référence article",
  "DESCRIPTION": "Description",
  "QUANTITY": "Quantité",
  "PRICE": "Prix",
  "DISCOUNT": "Remise",
  "DISCOUNTED_PRICE": "Prix remisé",
  "TOTAL_PRICE": "Prix total",
  "TOTAL_PRICE_AFTER_DISCOUNT": "Prix total après remise",
  "NEW_PRODUCTS": "Nouveaux produits",
  "MY_ACCOUNT": "Mon compte",
  "PRICE_LIST": "Liste de prix",
  "PARTIAL_DELIVERY_EXPECTED": "Livraison partielle, première livraison {{date}}",
  "ENTRY_IN_PROGRESS": "Saisie en cours",
  "ENTERED": "Saisi",
  "PICKING_IN_PROGRESS": "Préparation en cours",
  "INVOICED": "Facturé",
  "TOP_PRODUCTS": "Produits phares",
  "NOT_ADD_BROCHURES": "I do not want brochures",
  "ADD_BROCHURES": "Add brochures",
  "BROCHURES_DECISION_NECESSARY": "Brochures decision necessary",
  "SPARE_PARTS": "Pièces détachées",
  "TOTAL_VAT_INCLUDED": "TVA totale incluse: ",
  "VAT_PRECENTAGE": "TVA %",
  "VAT_VALUE": "Valeur de la TVA: ",
  "SAVE_AND_EMAIL_QUOTATION": "Enregistrer et envoyer par e-mail",
  "TO_BE_PHASED_OUT": "En cours d'abandon",
  "TARIFF_CODE": "Code tarifaire",
  "REPLACES_NUMBER": "Remplace le numéro",
  "REPLACES_PRODUCT": "Remplace le produit",
  "NEWS_BANNER": "Nouveau",
  "CAMPAIGN_UNTIL": "Campagne jusqu'au",
  "NEW_PRICE_FROM": "Nouveau prix à partir du",
  "PRESELECTED_CUSTOMER_ID": "ID client présélectionné",
  "CHANGE_ACCOUNT": "Changer de compte",
  "CONTACT_YOUR_SALES_REPRESENTATIVE": "Contactez votre représentant commercial"
}
